import { Redirect, useLocation } from 'react-router-dom';

export const TradePartners = () => {
  const { pathname } = useLocation();

  if (pathname.includes('/payments/') || pathname.includes('/invoices/')) {
    return <Redirect to={pathname.replace('trade-partners', 'vendors')} />;
  }

  return <Redirect to="/vendors" />;
};
